import { useMutation } from '@tanstack/react-query';
import { advisorAdminApi } from '../api/api';

export function useClientSearch() {
  const mutation = useMutation({
    mutationFn: (clientId: string) =>
      advisorAdminApi.searchClient({ clientId: clientId.trim() }),
  });

  return {
    searchClient: mutation.mutate,
    client: mutation.data?.client ?? null,
    advisor: mutation.data?.advisor ?? null,
    surveys: mutation.data?.surveys ?? null,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
